<div class="card text-left">
  <div class="card-body" style="background-color: #e4ecf2;">
    <h4 class="card-title" style="text-align: center;">Skills Training Provider (STP) Registration</h4>
  </div>
</div>

<nz-alert
  *ngIf="isRenewalPending"
  class="mt-3"
  nzType="warning"
  nzShowIcon
  nzMessage="Editing is not available"
  nzDescription="This STP has a renewal / re-apply application in progress. Its information can't be edited until a decision is given on that application, because the approval would replace these changes."
></nz-alert>

<nz-tabset
  *ngIf="isStatusChecked && !isRenewalPending"
  nzType="card"
  nzCentered
  [(nzSelectedIndex)]="selectedIndex"
>
  <nz-tab nzTitle="Basic Profile">
    <app-admin-basic-profile></app-admin-basic-profile>
  </nz-tab>

  <nz-tab nzTitle="Physical Infrastructure">
    <app-admin-physical-infra></app-admin-physical-infra>
  </nz-tab>

  <nz-tab nzTitle="Trainer">
    <app-admin-occupation-specific-trainer></app-admin-occupation-specific-trainer>
  </nz-tab>

  <nz-tab nzTitle="Management & Staff">
    <app-admin-management-and-staffs></app-admin-management-and-staffs>
  </nz-tab>

  <nz-tab nzTitle="Financial Details">
    <app-admin-financial-details></app-admin-financial-details>
  </nz-tab>

  <nz-tab nzTitle="Occupation Specific Tools">
    <app-admin-occupation-specific-tools></app-admin-occupation-specific-tools>
  </nz-tab>

  <nz-tab nzTitle="Furniture">
    <app-admin-furniture-list></app-admin-furniture-list>
  </nz-tab>

  <nz-tab nzTitle="Payment">
    <app-admin-stp-payment></app-admin-stp-payment>
  </nz-tab>

</nz-tabset>
